"use client";
import { useEffect, useState } from "react";
import BadgeHandler from "./BadgeHandler";
import SnackbarHandler from "./SnackbarHandler";
import { setBadgeUpdater } from "../util/badgeUpdater";
import { setSnackbarUpdater } from "../util/snackbarUpdater";
import { useAuth, userHasAnyAdminAccessState } from "../util/auth";

const Notifications = () => {
  const auth = useAuth() as any;
  const [badges, setBadges] = useState([]);
  const [snackbar, setSnackbar] = useState({ message: null, severity: "info" });

  useEffect(() => {
    setBadgeUpdater(setBadges);
    setSnackbarUpdater(setSnackbar);
  }, []);

  const isAdmin = userHasAnyAdminAccessState(auth?.user) === true;

  return (
    <>
      {/* Badge notification popup(s) — admin-only until public release */}
      {isAdmin && Array.isArray(badges) && badges.length > 0 && (
        <BadgeHandler badges={badges} setBadges={setBadges} />
      )}

      {/* Snackbar notification */}
      {snackbar && snackbar.message && (
        <SnackbarHandler
          content={snackbar}
          setMessage={() => setSnackbar({ message: null, severity: "info" })}
        />
      )}
    </>
  );
};

export default Notifications;
